var _path, _g, _path2, _circle, _path3, _g2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentGeneration = function SvgContentGeneration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181,
    height: 181,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#content_generation_svg__a)",
    d: "M98.04 22.625H52.79c-8.33 0-15.083 6.753-15.083 15.083v105.584c0 8.33 6.753 15.083 15.084 15.083h75.416c8.331 0 15.084-6.753 15.084-15.083V67.875l-45.25-45.25Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#content_generation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#content_generation_svg__c)",
    d: "M98.043 67.875v-45.25l45.25 45.25h-45.25Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.332 98.042a7.542 7.542 0 0 1 7.542-7.542h45.25a7.542 7.542 0 0 1 0 15.083h-45.25a7.541 7.541 0 0 1-7.542-7.541ZM60.332 128.208a7.541 7.541 0 0 1 7.542-7.541h45.25a7.542 7.542 0 1 1 0 15.083h-45.25a7.542 7.542 0 0 1-7.542-7.542Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 130.5,
    r: 15.5,
    fill: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M137.855 123.855a.83.83 0 0 0-.83.831v9.964a3.32 3.32 0 0 0 3.318 3.321h8.307c1.267 0 2.139-.546 2.666-1.279.497-.69.655-1.494.655-2.042a.83.83 0 0 0-.83-.83h-2.491v-9.134a.83.83 0 0 0-.831-.831h-9.964Zm4.982 9.965h4.152v-8.304h-8.304v9.134c0 .917.744 1.661 1.661 1.661h.003a1.963 1.963 0 0 0 1.069-.342c.305-.22.589-.593.589-1.319a.83.83 0 0 1 .83-.83Zm.439 2.491H148.65c.725 0 1.099-.284 1.319-.589a1.69 1.69 0 0 0 .143-.242h-6.531a3.16 3.16 0 0 1-.305.831Zm-2.93-8.304a.83.83 0 0 1 .831-.83h3.321a.83.83 0 1 1 0 1.661h-3.321a.83.83 0 0 1-.831-.831Zm.831 1.661a.83.83 0 1 0 0 1.661h3.321a.83.83 0 0 0 0-1.661h-3.321Z",
    clipRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#content_generation_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 130.5,
    r: 15.5,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M139.16 122.363c-.5 0-.904.404-.904.904v14.466c0 .5.404.905.904.905h10.85a.905.905 0 0 0 .904-.905v-10.85a.904.904 0 0 0-.265-.639l-3.617-3.617a.904.904 0 0 0-.639-.264h-7.233Zm.904 14.466v-12.658h5.955l3.087 3.087v9.571h-9.042Zm1.808-6.329a.904.904 0 0 0 0 1.808h5.425a.904.904 0 1 0 0-1.808h-5.425Zm-.904-1.808c0-.5.405-.904.904-.904h3.617a.904.904 0 1 1 0 1.808h-3.617a.904.904 0 0 1-.904-.904Zm.904 4.521a.904.904 0 1 0 0 1.808h5.425a.905.905 0 1 0 0-1.808h-5.425Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#content_generation_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#content_generation_svg__f)",
    d: "M38 78c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.639,
    d: "M47.168 57.853a9.834 9.834 0 1 1-9.834-9.834M27.5 57.853h11.347m-1.512-9.834a16.974 16.974 0 0 0-3.783 9.834 16.975 16.975 0 0 0 3.783 9.833 16.976 16.976 0 0 0 3.51-7.563m-2.049-7.995c-.574-.099-.574-.925 0-1.025a5.205 5.205 0 0 0 4.194-4.015l.033-.159c.126-.569.934-.574 1.065-.005l.041.185a5.233 5.233 0 0 0 4.206 3.991c.577.1.577.931 0 1.033a5.234 5.234 0 0 0-4.206 3.99l-.04.184c-.132.567-.94.564-1.066-.005l-.033-.157a5.206 5.206 0 0 0-4.194-4.017Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_generation_svg__a",
    x1: 90.499,
    x2: 90.499,
    y1: 22.625,
    y2: 158.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CB4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5689C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_generation_svg__c",
    x1: 121,
    x2: 98,
    y1: 41.5,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5183BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C95D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "content_generation_svg__f",
    x1: 38,
    x2: 38,
    y1: 38,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "content_generation_svg__b",
    width: 53.25,
    height: 53.25,
    x: 92.043,
    y: 22.625,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.321569 0 0 0 0 0.517647 0 0 0 0 0.741176 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5882_101838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5882_101838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "content_generation_svg__d",
    width: 71,
    height: 71,
    x: 109,
    y: 101,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5882_101838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5882_101838",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "content_generation_svg__e",
    width: 50.074,
    height: 50.074,
    x: 15.481,
    y: 35.481,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.519,
    dy: 2.519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5882_101838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5882_101838",
    result: "shape"
  })))));
};
export default SvgContentGeneration;